// wordpressなので、jQueryは外部読み込みが簡単
import "./style.scss";

window.$ = require('jquery');

//----------------------------------------------------------
// アンカースクロール
function scrollToAnchor(hash, $header) {
  let $target = $(hash);
  if ($target.length > 0) {
    let pos = $target.offset().top;
    pos -= $header.outerHeight();
    if (pos < 0) pos = 0;
    $('body, html').stop().animate({
      scrollTop: pos
    }, 500);
  }
}

//----------------------------------------------------------
$(() => {
  "use strict";
  // タッチデバイス判定
  let isTouchDevice = (window.ontouchstart === null);
  if (isTouchDevice) {
    $("body").addClass("is_touchDevice");
  } else {
    $("body").addClass("is_notTouchDevice");
  }
  // ページ初期化
  let $ptb = $(".page-top-button");
  $ptb.fadeOut(0);
  let $sp_nav_opener = $(".menu-trigger");
  $sp_nav_opener.on("click", function() {
    if ($sp_nav_opener.hasClass("active")) {
      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
      $sp_nav_opener.removeClass("active");
    } else {
      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
      const body = document.body;
      body.style.top = `-${scrollY}`;
      body.style.position = 'fixed';
      $sp_nav_opener.addClass("active");
    }
  });
  window.addEventListener('scroll', () => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
  });

  // スクロールイベント
  const $header = $("#globalHeader"); // global header要素
  let serviceScrollTops = [],
    serviceScrollTopsIds = [],
    serviceCurrentIndex;
  $(document).on("scroll", function() {
    const st = $(window).scrollTop();
    if (serviceScrollTops.length) {
      let pos = serviceScrollTops.findIndex((element) => element >= st);
      if (pos != serviceCurrentIndex) {
        $(".js-service-navi").removeClass("active").filter("[href='#" + serviceScrollTopsIds[pos] + "']").addClass("active");
        serviceCurrentIndex = pos;
      }
    }
    if (st > 300) {
      $ptb.fadeIn();
    } else {
      $ptb.fadeOut();
    }
  });

  // リサイズイベント
  const $serviceScrollNavi = $(".js-check-scroll-position");
  $(window).on("resize", function() {
    serviceScrollTops = [];
    serviceScrollTopsIds = [];
    serviceCurrentIndex = -1;
    if ($(this).width() >= 769 && $serviceScrollNavi.length > 0) {
      $serviceScrollNavi.find("li").each(function() {
        serviceScrollTops.push($(this).offset().top);
        serviceScrollTopsIds.push($(this).attr("id"));
      });
    }
  }).trigger("resize");

  // よくあるご質問
  $(".js-next-open").on("click", function() {
    let tag = $(this).data('next');
    const $next = $(this).next(tag);
    if (!$next.is(":visible")) {
      $(this).addClass("active");
    } else {
      $(this).removeClass("active");
    }
    $next.slideToggle(500);
  });

  // ハッシュタグ付きリンクのスムーススクロール化
  $('a[href^="#"]').on("click", function() {
    let href = $(this).attr("href");
    let hash = href == "#" || href == "" ? "html" : href;
    scrollToAnchor(hash, $header);
    return false;
  });
  let urlHash = location.hash;
  if (urlHash) {
    $('body, html').stop().scrollTop(0);
    setTimeout(function() {
      scrollToAnchor(urlHash, $header);
    }, 100);
  }
});